import { Gradients } from "apparatus/gradients";
import { P, Pivot, R, SharedColors } from "apparatus/library/common";
import { SVG } from "apparatus/svg";
import { Group, Path, PointText } from "paper";
export class Timer {
    render(appearance) {
        const shape = appearance.type;
        switch (shape) {
            case "rectangular":
                return renderRectangularTimer(appearance);
            case "round":
            default:
                return renderRoundTimer(appearance);
        }
    }
    static convertToLatest(old) {
        if (!old.type) {
            old.type = "rectangular";
        }
        return old;
    }
}
Timer.properties = {
    label: "Timer / Stopwatch",
    defaultAppearance: {
        type: "round",
        label: "1:00"
    },
    appearanceSpecs: [
        {
            spec: "toggle-buttons", key: "type", label: "Type", size: "text",
            options: [
                { value: "round", label: "Round" },
                { value: "rectangular", label: "Rectangular" },
            ],
        },
        {
            spec: "text", key: "label", label: "Label",
        }
    ],
};
function renderRoundTimer(appearance) {
    // Stopwatch icon
    const icon = SVG.timer().withScale(0.08, P(0, 0));
    // Display text
    const text = new PointText({
        point: P(45, 30),
        content: appearance.label,
        fillColor: 'black',
        fontFamily: 'sans-serif',
        fontSize: 20,
    });
    const graphic = new Group([icon, text]);
    return { graphic: graphic, hitShape: graphic.bounds.toShape() };
}
function renderRectangularTimer(appearance) {
    const width = 80;
    const height = 54;
    // Case
    const casing = new Path.Rectangle(R(0, 0, width, height), 8)
        .withStroke("default")
        .withGradientFill("down", Gradients.box("#cccccc".color(), { shift: 0.1 }));
    // Screen
    const screenWidth = width - 16;
    const screenOutline = new Path.Rectangle(R(8, 8, width - 16, height - 28), 4)
        .withStroke("thin", "#666666")
        .withFill(SharedColors.lcdScreen);
    // Display text
    const textCenter = P(width / 2, height - 26);
    const displayText = new PointText({
        point: textCenter,
        content: appearance.label,
        fillColor: 'black',
        fontFamily: 'sans-serif',
        fontSize: 16,
        justification: "center",
    });
    const maxTextWidth = screenWidth - 6;
    if (displayText.bounds.width > maxTextWidth) {
        displayText.scale(maxTextWidth / displayText.bounds.width, screenOutline.bounds.center);
    }
    const screen = new Group([screenOutline, displayText]);
    // Buttons
    const buttonY = height - 10;
    const button1 = new Path.Circle(P(width / 2 - 20, buttonY), 5)
        .withStroke("thin")
        .withFill("#d175759b");
    const button2 = new Path.Circle(P(width / 2, buttonY), 5)
        .withStroke("thin")
        .withFill("#74c374ff");
    const button3 = new Path.Circle(P(width / 2 + 20, buttonY), 5)
        .withStroke("thin")
        .withFill("#4a4a9bff");
    const buttons = new Group([button1, button2, button3]);
    const topButtons = (new Group([
        new Path.Rectangle(R(5, 0, 15, 6, Pivot.BOTTOM_LEFT), 2),
        new Path.Rectangle(R(25, 0, 15, 6, Pivot.BOTTOM_LEFT), 2),
    ])
        .withStroke("default")
        .withFill("#aaaaaa"));
    const graphic = new Group([topButtons, casing, screen, buttons]);
    return {
        graphic: graphic,
        hitShape: graphic.bounds.toShape(),
        snapping: casing.placeable(),
    };
}
